import PropTypes from 'prop-types';
import React from 'react';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';

const TOOLBAR = [
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
];

const WysiwygEditor = ({
  value,
  onChange,
  onBlur,
  placeholder,
  className,
}) => (
  <ReactQuill
    theme="snow"
    value={value || ''}
    onChange={onChange}
    onBlur={onBlur}
    placeholder={placeholder}
    className={className}
    modules={{ toolbar: TOOLBAR }}
  />
);

WysiwygEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

WysiwygEditor.defaultProps = {
  value: '',
  onBlur: () => {},
  placeholder: '',
  className: '',
};

export default WysiwygEditor;
